<script>import { createEventDispatcher, onMount } from "svelte";
const dispatch = createEventDispatcher();
let loaded = typeof window != "undefined" && "turnstile" in window;
let mounted = false;
export let widgetId = null;
export let turnstile = null;
$: turnstile = loaded && window.turnstile || null;
export let siteKey;
export let appearance = "always";
export let language = "auto";
export let execution = "render";
export let action = void 0;
export let cData = void 0;
export let retryInterval = 8e3;
export let retry = "auto";
export let refreshExpired = "auto";
export let theme = "auto";
export let size = "normal";
export let tabIndex = 0;
export let forms = void 0;
export let responseField = void 0;
export let formsField = void 0;
export let responseFieldName = void 0;
let _class = void 0;
export { _class as class };
export const reset = () => {
  widgetId && window?.turnstile?.reset(widgetId);
};
$: renderParams = {
  sitekey: siteKey,
  callback: (token, preClearanceObtained) => {
    dispatch("callback", { token, preClearanceObtained });
    dispatch("turnstile-callback", { token, preClearanceObtained });
  },
  "error-callback": (code) => {
    dispatch("error", { code });
    dispatch("turnstile-error", { code });
  },
  "timeout-callback": () => {
    dispatch("timeout", {});
    dispatch("turnstile-timeout", {});
  },
  "expired-callback": () => {
    dispatch("expired", {});
    dispatch("turnstile-expired", {});
  },
  "before-interactive-callback": () => {
    dispatch("before-interactive", {});
  },
  "after-interactive-callback": () => {
    dispatch("after-interactive", {});
  },
  "unsupported-callback": () => dispatch("unsupported", {}),
  "response-field-name": responseFieldName ?? formsField ?? "cf-turnstile-response",
  "response-field": responseField ?? forms ?? true,
  "refresh-expired": refreshExpired,
  "retry-interval": retryInterval,
  tabindex: tabIndex,
  appearance,
  execution,
  language,
  action,
  retry,
  theme,
  cData,
  size
};
const turnstileAction = (node, renderParams2) => {
  let id = window.turnstile.render(node, renderParams2);
  widgetId = id;
  return {
    destroy() {
      window.turnstile.remove(id);
    },
    update(newRenderParams) {
      window.turnstile.remove(id);
      id = window.turnstile.render(node, newRenderParams);
      widgetId = id;
    }
  };
};
onMount(() => {
  mounted = true;
  if (!loaded) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.addEventListener("load", () => loaded = true, {
      once: true
    });
    document.head.appendChild(script);
  }
  return () => {
    mounted = false;
  };
});
</script>

{#if loaded && mounted}
	<div
		use:turnstileAction={renderParams}
		class:flexible={size == 'flexible'}
		class={_class}>
	</div>
{/if}

<style>
	:where(.flexible) {
		min-width: 300px;
		width: 100%;
	}
</style>
